module.exports = __webpack_public_path__ + "static/media/article15.98ac7964.webp";